export default __webpack_public_path__ + "static/media/AdobeStock_158327206_x3.50c21847.jpg";